import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { brand } from '../mock';
import Reveal from './Reveal';
import ContactForm from './ContactForm';

const ContactPage = () => {
  return (
    <main className="bg-[#262629] pt-40 md:pt-48 pb-8 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 mb-4">
        <Reveal>
          <p className="font-display text-white/50 text-sm tracking-[0.2em] uppercase mb-3">Get in touch</p>
          <h1 className="font-display text-yellow text-5xl md:text-7xl mb-5">Let's price your next project</h1>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-2xl mb-10">
            Send us your project details and we'll come back with a fixed-fee proposal. Prefer to talk it through?
            Call, email or text — whichever is easiest for you.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-4">
            <a href={brand.phoneHref} className="rounded-2xl bg-[#353539] border border-white/5 p-6 flex items-center gap-4 hover:border-yellow/40 transition-colors">
              <span className="w-11 h-11 rounded-full bg-jaw-yellow flex items-center justify-center shrink-0">
                <Phone className="w-5 h-5 text-[#262629]" strokeWidth={2.5} />
              </span>
              <span>
                <span className="block text-white/50 text-sm">Call us</span>
                <span className="block text-white font-semibold">{brand.phone}</span>
              </span>
            </a>
            <a href={`mailto:${brand.email}`} className="rounded-2xl bg-[#353539] border border-white/5 p-6 flex items-center gap-4 hover:border-yellow/40 transition-colors">
              <span className="w-11 h-11 rounded-full bg-jaw-yellow flex items-center justify-center shrink-0">
                <Mail className="w-5 h-5 text-[#262629]" strokeWidth={2.5} />
              </span>
              <span className="min-w-0">
                <span className="block text-white/50 text-sm">Email us</span>
                <span className="block text-white font-semibold truncate">{brand.email}</span>
              </span>
            </a>
            <div className="rounded-2xl bg-[#353539] border border-white/5 p-6 flex items-center gap-4">
              <span className="w-11 h-11 rounded-full bg-jaw-yellow flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-[#262629]" strokeWidth={2.5} />
              </span>
              <span>
                <span className="block text-white/50 text-sm">Based in</span>
                <span className="block text-white font-semibold">Plymouth, UK</span>
              </span>
            </div>
          </div>
        </Reveal>
      </div>

      <ContactForm />
    </main>
  );
};

export default ContactPage;
